import { apiFetch } from '@/api/client'
import { WeeklyReport } from '@/components/report/WeeklyReport'
import { ReportData } from '@/components/report/reportData'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { z } from 'zod'

/** 24 Oct 2026: admin preview of the weekly report (live data, not frozen).
 *  ?print=1 opens the print window (Save as PDF). */
export const Route = createFileRoute('/report/$siteId')({
  validateSearch: z.object({
    week: z.string().optional().catch(undefined),
    for: z.string().optional().catch(undefined),
    print: z.coerce.number().optional().catch(undefined),
  }),
  component: ReportPreview,
})

function ReportPreview() {
  const { siteId } = Route.useParams()
  const search = Route.useSearch()
  const base = `/api/sites/${encodeURIComponent(siteId)}`
  const q = useQuery({
    queryKey: ['weekly-report-draft', siteId, search.week ?? null],
    queryFn: () => apiFetch(`${base}/weekly-report/draft${search.week ? `?week=${search.week}` : ''}`, ReportData),
  })
  const data = q.data ? { ...q.data, prepared_for: search.for?.slice(0, 60) || null } : null
  useEffect(() => {
    if (data) document.title = `${data.site_name} · Weekly site report`
    if (data && search.print) {
      const t = setTimeout(() => window.print(), 900)
      return () => clearTimeout(t)
    }
  }, [data, search.print])
  if (q.isError) return <p style={{ padding: 24 }}>Could not load the report (admins only).</p>
  if (!data) return <div style={{ minHeight: '100vh', background: '#E9E4DA' }} />
  return (
    <>
      {!search.print ? (
        <div className="zr-noprint" style={{ background: '#FCEBD8', color: '#8A5212', textAlign: 'center', fontSize: 13, padding: 8 }}>
          Preview with today's data – only admins can see this page.
        </div>
      ) : null}
      <WeeklyReport data={data} photoSrc={(p) => `${base}/events/${p.event_id}/image`} />
    </>
  )
}
